import React from 'react';
import './style.css';
import mixpanel from 'mixpanel-browser';

export const PlayStoreBadge = () => (
  <a href='https://play.google.com/store/apps/details?id=com.strikelab&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank" rel="noopener noreferrer" onClick={() => mixpanel.track('Play Store badge click')}><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'className='play-store-badge'/></a>
);